module.exports = __webpack_public_path__ + "2d7d35cf5712c5cf57365366ce81736f.jpg";